import { createBrowserRouter, Navigate } from 'react-router';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    LoginRoutes,
    MainRoutes,
    {
      path: '*',
      element: <Navigate to="/maintenance/404" replace />
    }
  ],
  { basename: import.meta.env.VITE_APP_BASE_NAME }
);

export default router;
